import { createTheme } from '@mui/material';
import themecfg, { ThemeCfg } from 'App.theme';

// allow setting the Theme cfg in the MUI Theme
declare module '@mui/material/styles' {
  interface Theme extends ThemeCfg {}
  interface ThemeOptions extends ThemeCfg {}
}

const theme = createTheme({
  ...themecfg,
  palette: {
    primary: { main: themecfg.colors.primary, dark: themecfg.colors.primaryDark },
    secondary: { main: themecfg.colors.black },
    success: { main: themecfg.colors.green },
    error: { main: themecfg.colors.red },
    warning: { main: themecfg.colors.orange },
    info: { main: themecfg.colors.info },
    action: { active: themecfg.colors.active },
  },
  typography: {
    fontFamily: themecfg.font,
  },
  components: {
    MuiTypography: {
      variants: [
        {
          props: { variant: 'h1' },
          style: {
            fontSize: '28px',
            fontWeight: 500,
          },
        },
        {
          props: { variant: 'h2' },
          style: {
            fontSize: '24px',
            fontWeight: 400,
          },
        },
        {
          props: { variant: 'h3' },
          style: {
            fontSize: '22px',
            fontWeight: 300,
            margin: '16px 0',
          },
        },
      ],
    },
  },
});

export default theme;
